




import { Component, Mixins } from 'vue-property-decorator'
import CookieMethods from '@/mixins/CookieMethods.vue'

@Component
export default class Home extends Mixins(CookieMethods) {
  private mounted() {
    if (this.isTokensExist) {
      switch (this.currentUserRole) {
        case 'admin':
          // 管理者ユーザ
          this.$router.push({ name: 'AdminBranchList' })
          break
        case 'student':
          // 生徒ユーザ
          this.$router.push({ name: 'StudentStudyStart' })
          break
        case 'branch':
          // 教室ユーザ
          this.$router.push({ name: 'BranchStudentList' })
          break
        default:
          // 権限未取得として生徒ログイン画面へ遷移
          this.$router.push({ name: 'StudentLogin' })
      }
    } else {
      this.$router.push({ name: 'StudentLogin' })
    }
  }
}
